<script setup>
import { computed, shallowRef, watch } from 'vue';
import { initials } from '@/utils/format';

// shadcn Avatar: the photo when there is one, otherwise initials on a grey
// circle (also the fallback when the photo fails to load).
const props = defineProps({
  name: { type: String, default: '' },
  src: { type: String, default: '' },
  size: { type: Number, default: 32 },
});

const failed = shallowRef(false);
watch(() => props.src, () => (failed.value = false));

const style = computed(() => ({
  width: `${props.size}px`,
  height: `${props.size}px`,
  fontSize: `${Math.round(props.size * 0.38)}px`,
}));
</script>

<template>
  <span class="ui-avatar" :style="style" :title="name">
    <img v-if="src && !failed" :src="src" :alt="name" @error="failed = true" />
    <template v-else>{{ initials(name) || '?' }}</template>
  </span>
</template>

<style scoped>
.ui-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
  border-radius: 9999px;
  background-color: var(--accent);
  color: var(--secondary-foreground);
  font-weight: 500;
  line-height: 1;
  user-select: none;
}
.ui-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
